import script from "./EditPostCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./EditPostCard.vue?vue&type=script&setup=true&lang=ts"

import "./EditPostCard.vue?vue&type=style&index=0&id=9499e5f2&scoped=true&lang=css"

import exportComponent from "/home/circleci/project/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9499e5f2"]])

export default __exports__